module.exports = __webpack_public_path__ + "static/img/env3.08037bbc.png";